module.exports = {
	"root": "findify-components-common--picture",
	"aspect": "findify-components-common--picture__aspect",
	"thumbnail": "findify-components-common--picture__thumbnail",
	"ready": "findify-components-common--picture__ready",
	"static": "findify-components-common--picture__static"
};